var _circle, _circle2, _circle3, _g, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVersion2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 160,
    viewBox: "0 0 188 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.03,
    cx: 94,
    cy: 80,
    r: 80,
    fill: "#00B63E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.06,
    cx: 94,
    cy: 80,
    r: 68,
    fill: "#00B63E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.09,
    cx: 94,
    cy: 80,
    r: 56,
    fill: "#00B63E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_155_141674)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 80,
    r: 45,
    fill: "#00B63E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.1902 56.5017L86.4429 66.3392H86.5711L89.8177 56.5017H92.3076L87.9015 69H85.1064L80.7064 56.5017H83.1902ZM96.9991 69.1831C96.0592 69.1831 95.2476 68.9878 94.5641 68.5972C93.8846 68.2026 93.3618 67.6452 92.9957 66.9251C92.6295 66.2009 92.4464 65.3486 92.4464 64.3681C92.4464 63.4038 92.6295 62.5576 92.9957 61.8293C93.3659 61.097 93.8826 60.5274 94.5458 60.1206C95.2089 59.7097 95.988 59.5042 96.8831 59.5042C97.4608 59.5042 98.006 59.5978 98.5186 59.7849C99.0353 59.968 99.491 60.2528 99.8856 60.6393C100.284 61.0258 100.598 61.5181 100.825 62.1162C101.053 62.7102 101.167 63.4181 101.167 64.2399V64.9173H93.4839V63.4282H99.0496C99.0455 63.0051 98.9539 62.6288 98.7749 62.2992C98.5959 61.9656 98.3457 61.7032 98.0243 61.512C97.707 61.3208 97.3367 61.2252 96.9136 61.2252C96.462 61.2252 96.0653 61.335 95.7236 61.5547C95.3818 61.7703 95.1154 62.0551 94.9241 62.4091C94.737 62.759 94.6414 63.1434 94.6373 63.5625V64.8624C94.6373 65.4075 94.737 65.8754 94.9363 66.266C95.1357 66.6525 95.4144 66.9495 95.7724 67.157C96.1304 67.3604 96.5495 67.4621 97.0296 67.4621C97.351 67.4621 97.6419 67.4174 97.9023 67.3279C98.1626 67.2343 98.3884 67.098 98.5797 66.919C98.7709 66.74 98.9153 66.5182 99.0129 66.2538L101.076 66.4857C100.945 67.0309 100.697 67.5069 100.331 67.9137C99.969 68.3165 99.5052 68.6298 98.9397 68.8535C98.3742 69.0732 97.7273 69.1831 96.9991 69.1831ZM103.036 69V59.6263H105.178V61.1886H105.276C105.447 60.6474 105.74 60.2304 106.155 59.9375C106.574 59.6405 107.052 59.492 107.589 59.492C107.711 59.492 107.847 59.4981 107.998 59.5103C108.152 59.5184 108.28 59.5327 108.382 59.553V61.5852C108.289 61.5527 108.14 61.5242 107.937 61.4998C107.737 61.4713 107.544 61.4571 107.357 61.4571C106.954 61.4571 106.592 61.5445 106.271 61.7195C105.953 61.8904 105.703 62.1284 105.52 62.4335C105.337 62.7386 105.245 63.0906 105.245 63.4893V69H103.036Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3758 99V96.2365L80.7073 89.0495C81.4084 88.3414 81.9927 87.7124 82.4602 87.1625C82.9277 86.6125 83.2782 86.0798 83.512 85.5642C83.7457 85.0486 83.8626 84.4987 83.8626 83.9144C83.8626 83.2475 83.7113 82.677 83.4089 82.2027C83.1064 81.7215 82.6905 81.3502 82.1612 81.089C81.6318 80.8278 81.0303 80.6972 80.3567 80.6972C79.6624 80.6972 79.054 80.8415 78.5315 81.1303C78.0091 81.4121 77.6035 81.8143 77.3148 82.3367C77.0329 82.8591 76.892 83.4813 76.892 84.2031H73.2521C73.2521 82.8626 73.558 81.6974 74.1698 80.7075C74.7816 79.7176 75.6237 78.9511 76.6961 78.408C77.7754 77.865 79.0127 77.5934 80.4082 77.5934C81.8243 77.5934 83.0686 77.8581 84.141 78.3874C85.2134 78.9167 86.0451 79.642 86.6363 80.5631C87.2344 81.4843 87.5334 82.5361 87.5334 83.7184C87.5334 84.509 87.3822 85.2858 87.0797 86.0488C86.7773 86.8119 86.2445 87.6574 85.4815 88.5854C84.7253 89.5135 83.6632 90.6374 82.2952 91.9573L78.6553 95.6591V95.8035H87.8531V99H73.3758ZM93.7512 99.2269C93.1257 99.2269 92.5895 99.0069 92.1426 98.5669C91.6958 98.127 91.4758 97.5908 91.4827 96.9583C91.4758 96.3396 91.6958 95.8103 92.1426 95.3704C92.5895 94.9304 93.1257 94.7104 93.7512 94.7104C94.3562 94.7104 94.8821 94.9304 95.3289 95.3704C95.7826 95.8103 96.0129 96.3396 96.0198 96.9583C96.0129 97.3777 95.9029 97.7592 95.6898 98.1029C95.4836 98.4466 95.2086 98.7216 94.8649 98.9278C94.528 99.1272 94.1568 99.2269 93.7512 99.2269ZM106.816 99.4021C105.118 99.4021 103.661 98.9725 102.444 98.1132C101.234 97.2471 100.302 95.9994 99.6494 94.3702C99.0032 92.7341 98.6801 90.7646 98.6801 88.4617C98.687 86.1588 99.0135 84.1996 99.6597 82.5842C100.313 80.9618 101.244 79.7245 102.454 78.8721C103.671 78.0196 105.125 77.5934 106.816 77.5934C108.507 77.5934 109.961 78.0196 111.178 78.8721C112.394 79.7245 113.326 80.9618 113.972 82.5842C114.625 84.2065 114.952 86.1657 114.952 88.4617C114.952 90.7715 114.625 92.7444 113.972 94.3805C113.326 96.0097 112.394 97.2539 111.178 98.1132C109.968 98.9725 108.514 99.4021 106.816 99.4021ZM106.816 96.1747C108.136 96.1747 109.177 95.525 109.94 94.2258C110.71 92.9197 111.095 90.9983 111.095 88.4617C111.095 86.7844 110.92 85.3751 110.569 84.234C110.219 83.0929 109.724 82.2336 109.084 81.6561C108.445 81.0718 107.689 80.7797 106.816 80.7797C105.503 80.7797 104.465 81.4327 103.702 82.7388C102.939 84.0381 102.554 85.9457 102.547 88.4617C102.54 90.1459 102.708 91.562 103.052 92.71C103.403 93.858 103.898 94.7242 104.537 95.3085C105.176 95.8859 105.936 96.1747 106.816 96.1747Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 152.172,
    y: 126,
    width: 3.15844,
    height: 3.15844,
    rx: 1,
    transform: "rotate(43.4398 152.172 126)",
    fill: "#138B3C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76.3145,
    y: 20.5791,
    width: 3.15844,
    height: 3.15844,
    rx: 1,
    transform: "rotate(120 76.3145 20.5791)",
    fill: "#138B3C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0776,
    y: 89.9253,
    width: 3.15844,
    height: 3.15844,
    rx: 1,
    transform: "rotate(42.9615 38.0776 89.9253)",
    fill: "#138B3C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 177.06,
    y: 113.717,
    width: 3.15844,
    height: 3.15844,
    rx: 1,
    transform: "rotate(-31.6563 177.06 113.717)",
    fill: "#6FDA93"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62.5708,
    y: 144.617,
    width: 3.15844,
    height: 3.15844,
    rx: 1,
    transform: "rotate(-0.840569 62.5708 144.617)",
    fill: "#6FDA93"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2686,
    y: 136,
    width: 3.15844,
    height: 3.15844,
    rx: 1,
    transform: "rotate(45.917 12.2686 136)",
    fill: "#6FDA93"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 68.6577,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(-31.6563 152 68.6577)",
    fill: "#6FDA93"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 73.0496,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(-31.6563 185 73.0496)",
    fill: "#6FDA93"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 71.0496,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(-31.6563 0 71.0496)",
    fill: "#6FDA93"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 39.0496,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(-31.6563 178 39.0496)",
    fill: "#6FDA93"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 9.04956,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(-31.6563 100 9.04956)",
    fill: "#6FDA93"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 28.0496,
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(-31.6563 20 28.0496)",
    fill: "#6FDA93"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_155_141674",
    x: 49,
    y: 35,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_155_141674"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVersion2);
export default __webpack_public_path__ + "static/media/icon-version-2.299725961b712c2ecee861b09e418b54.svg";
export { ForwardRef as ReactComponent };